import { LazyRenderLayer } from 'core/layouts/ui-blocks/ReusableComponents';
import { ComponentLoadingScreen } from 'core/navigation/loading-screen/LoadingScreen';
import { musicVideoAudioCroppingModalSelector } from 'core/store/reducers/appReducer/AppSlice';
import React, { lazy, Suspense } from 'react';
import { useSelector } from 'react-redux';

const AudioCroppingModal = lazy(() => import('./AudioCroppingModal'));

function LazyAudioCroppingModal() {
	const { isModalOpen } = useSelector(musicVideoAudioCroppingModalSelector);

	return (
		<LazyRenderLayer isShown={isModalOpen}>
			<Suspense fallback={<ComponentLoadingScreen />}>
				<AudioCroppingModal />
			</Suspense>
		</LazyRenderLayer>
	);
}

export default LazyAudioCroppingModal;
